// Pre-computed chain values for MACRO Beneficios pills. Change PILL_BORDER_RADIUS
// here if the pills' borderRadius ever changes in the layouts.
import { chainGap, chainPadding } from '@doer/frontend-components/creativity-editor';

const PILL_BORDER_RADIUS = 26;
const TEXT_BREATHING = 12;

export const PILL_CHAIN_GAP = chainGap(PILL_BORDER_RADIUS, PILL_BORDER_RADIUS);
export const PILL_CHAIN_PADDING_LEFT = chainPadding(PILL_CHAIN_GAP, TEXT_BREATHING);
